export var PROGRESS_STEPPER_APPEARANCES = Object.freeze({
  COMPLETE: 'complete',
  INCOMPLETE: 'incomplete',
  WARNING: 'warning',
  ERROR: 'error',
  NONE: 'none'
});